import { createSlice } from "@reduxjs/toolkit";
import { userForgetPassword } from "./thunk";

export const initialState = {
  forgetSuccessMsg: null as string | null,
  forgetError: null as string | null,
};

const forgotPasswordSlice = createSlice({
  name: "forgotpwd",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
        .addCase(userForgetPassword.pending, (state) => {
            state.forgetError = null;
            state.forgetSuccessMsg = null;
        })
        .addCase(userForgetPassword.fulfilled, (state, action) => {
            state.forgetSuccessMsg = action.payload as string;
            state.forgetError = null;
        })
        .addCase(userForgetPassword.rejected, (state, action) => {
            state.forgetError = action.payload as string;
            state.forgetSuccessMsg = null;
        });
  }
});

export default forgotPasswordSlice.reducer;
